module.exports = __webpack_public_path__ + "static/assets/f413ec9c9c5f9dc4f5f053f982949f9a.svg";